module.exports = __webpack_public_path__ + "static/media/page-4.db55ec37.png";